import { render } from "./Deliveries.vue?vue&type=template&id=64ab1c6c"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"

import "./Deliveries.vue?vue&type=style&index=0&id=64ab1c6c&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__